import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Done = () => {
  return (
    <Text.Header2>{i18n.t('payroll_integrations.incidences.a3innuva.id.done.title')}</Text.Header2>
  )
}

export default Done
